"use client";

import { theme, util } from "@/common/theme";
import styled from "styled-components";
import BorderedIcon from "../../BorderedIcon";
import SplitText from "mono/components/SplitText";

export default function HomeMore() {
  return (
    <Wrapper>
      <div className="more__inner">
        <SplitText
          tag="h3"
          animation="charDoubleClipped"
          type="chars"
          dangerouslySetInnerHTML={{
            __html: "More About <strong>nine</strong>",
          }}
          animateOnScroll
        ></SplitText>
        <BorderedIcon href="/about-us" />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  ${util.inner}
  padding-top: 160rem;
  padding-bottom: 160rem;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ theme }) => theme.theme.background};
  position: relative;

  .more__inner {
    display: flex;

    flex-flow: column nowrap;
    gap: 50rem;
    justify-content: center;
    align-items: center;
  }

  h3 {
    font-weight: 100 !important;
    strong {
      font-size: inherit;
    }
  }
`;
